import React, { useMemo, useState } from "react";
import { BsCaretDownFill, BsCaretRightFill, BsPeople, BsPersonCheck, BsClipboardCheck, BsCheckCircle, BsClock, BsClipboardData } from "react-icons/bs";
import { Link } from 'react-router-dom';

const TreatmentsKpi = ({ 
    tableData = null, // Nuevo prop que viene desde DetailsTreatments
    treatments = [], // Fallback por compatibilidad
    filteredTreatments = [], // Fallback por compatibilidad
    showKPIs = true
}) => {
    const [showKPI, setShowKPI] = useState(showKPIs);

    // Función de cálculo de KPIs (fallback si no llegan datos de la tabla)
    const calculateKPIsFallback = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
            return {
                totalTreatments: 0,
                uniqueDoctors: 0,
                uniquePatients: 0,
                completed: 0,
                active: 0,
                cancelled: 0,
                pending: 0,
                suspended: 0,
                consentSigned: 0,
                consentPending: 0
            };
        }

        const uniqueDoctorIds = new Set();
        const uniquePatientIds = new Set();
        
        let completed = 0;
        let active = 0;
        let cancelled = 0;
        let pending = 0;
        let suspended = 0;
        let consentSigned = 0;
        let consentPending = 0;

        data.forEach(treatment => {
            // Count unique doctors
            if (treatment.doctor_info?.doctor_id) {
                uniqueDoctorIds.add(treatment.doctor_info.doctor_id);
            }

            // Count unique patients
            if (treatment.patient_info?.patient_id) {
                uniquePatientIds.add(treatment.patient_info.patient_id);
            }

            // Count status
            const status = String(treatment.treatment_info?.status || '').toLowerCase();
            switch (status) {
                case 'completed':
                    completed++;
                    break;
                case 'active':
                case 'in_progress':
                    active++;
                    break;
                case 'cancelled':
                    cancelled++;
                    break;
                case 'pending':
                    pending++;
                    break;
                case 'suspended':
                    suspended++;
                    break;
                default:
                    active++;
                    break;
            }

            // Count consent status
            if (treatment.consent_status?.is_required) {
                if (treatment.consent_status.is_signed) {
                    consentSigned++;
                } else {
                    consentPending++;
                }
            }
        });

        return {
            totalTreatments: data.length,
            uniqueDoctors: uniqueDoctorIds.size,
            uniquePatients: uniquePatientIds.size,
            completed,
            active,
            cancelled,
            pending,
            suspended,
            consentSigned,
            consentPending
        };
    };

    const kpis = useMemo(() => {
        let kpiData;
        let isFiltered = false;
        let totalRecords = 0;
        let visibleRecords = 0;

        if (tableData && tableData.kpiData) {
            // Usar datos calculados desde la tabla
            kpiData = tableData.kpiData;
            totalRecords = tableData.allTreatments ? tableData.allTreatments.length : 0;
            visibleRecords = tableData.visibleTreatments ? tableData.visibleTreatments.length : 0;
            isFiltered = totalRecords !== visibleRecords;
        } else {
            // Fallback al método anterior
            const currentData = filteredTreatments && filteredTreatments.length > 0 ? filteredTreatments : treatments;
            kpiData = calculateKPIsFallback(currentData);
            totalRecords = treatments.length;
            visibleRecords = currentData.length;
            isFiltered = filteredTreatments && treatments && filteredTreatments.length !== treatments.length;
        }

        return {
            ...kpiData,
            isFiltered,
            totalRecords,
            visibleRecords
        };
    }, [tableData, treatments, filteredTreatments]);

    const formatNumber = (value) => {
        if (typeof value === 'number') {
            return value.toLocaleString();
        }
        return value;
    };

    const toggleKPI = () => setShowKPI(prev => !prev);

    const kpiCards = [
        { 
            title: 'Total', 
            value: kpis.totalTreatments,
            icon: <BsClipboardData />, 
            iconColor: '#f5f2e8'
        },
        { 
            title: 'Doctors', 
            value: kpis.uniqueDoctors,
            icon: <BsPersonCheck />, 
            iconColor: '#e8f4fd'
        },
        { 
            title: 'Patients', 
            value: kpis.uniquePatients,
            icon: <BsPeople />, 
            iconColor: '#e8f5e8'
        },
        { 
            title: 'Completed', 
            value: kpis.completed,
            icon: <BsCheckCircle />, 
            iconColor: '#f0e8fd'
        },
        { 
            title: 'Active', 
            value: kpis.active,
            icon: <BsClipboardCheck />, 
            iconColor: '#e8f8f2'
        },
        { 
            title: 'Pending', 
            value: kpis.pending,
            icon: <BsClock />, 
            iconColor: '#fff2e8'
        }
    ];

    return (
        <>
        
                        
            {showKPI && (
                <div className="row gy-3 introbx_row">
                    {kpiCards.map((kpi, index) => (

                        <div key={index} className="col">
                            <div className="d-flex align-items-center gap-2 p-3 rounded-10 shadow-sm">
                                <div className="icon flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '2rem', height: '2rem', backgroundColor: '#E4E4FF', color: '#8381FF' }}>
                                    <span className="d-block material-symbols-outlined fs-lg">{kpi.icon}</span>
                                </div>
                                <div className="info flex-fill">
                                    <p className="fs-sm text-gray mb-0">{kpi.title}</p>
                                    <p className="lh-1 fw-semibold">{formatNumber(kpi.value)}</p>
                                </div>
                            </div>
                        </div>

                    ))}
                </div>
            )}
            
        </>
    );
};

export default TreatmentsKpi;